<div class="Filters" *ngIf="filterData">
  <div class="Filters-desktop">
    <div class="Wrap">
      <div class="Tabs">
        <div class="Currency FormElement FormElement--noMargin">
          <div class="CustomRadio CustomRadio--inline" data-cy="Filter-euro">
            <input 
              type="radio" 
              id="eurosDesktop" 
              name="currencyDesktop" 
              value="EUR" 
              [(ngModel)]="currency" 
              (click)="currencyService.setCurrency('EUR')">
            <label for="eurosDesktop">€</label>
          </div>
          <div class="CustomRadio CustomRadio--inline" data-cy="Filter-dollar">
            <input 
              type="radio" 
              id="dollarsDesktop" 
              name="currencyDesktop" 
              value="USD" 
              [(ngModel)]="currency" 
              (click)="currencyService.setCurrency('USD')">
            <label for="dollarsDesktop">$</label>
          </div>
        </div>
        <form [formGroup]="filtersForm">
          <ul>
            <li 
              class="Tab Tab--withLabel" 
              [class.Active]="isActiveTab('licences')" 
              (click)="onTabChange('licences')">
              <input type="radio" formControlName="category" id="licences" value="licences">
              <label for="licences">Licences</label>
            </li>
            <li 
              class="Tab Tab--withLabel" 
              [class.Active]="isActiveTab('awards')" 
              (click)="onTabChange('awards')">
              <input type="radio" formControlName="category" id="awards" value="awards">
              <label for="awards">Awards</label>
            </li>
            <li 
              class="Tab Tab--withLabel" 
              [class.Active]="isActiveTab('reports')" 
              (click)="onTabChange('reports')">
              <input type="radio" formControlName="category" id="reports" value="reports">
              <label for="reports">Reports (2)</label>
            </li>
          </ul>
          <div class="TabContent">
            <div class="row">
              <div class="col-lg-2 Filter-region">
                <div class="FormElement">
                  <div 
                    formArrayName="regions" 
                    *ngFor="let region of filtersForm.controls.regions.controls; let i = index" 
                    class="CustomCheckbox CustomCheckbox--inline" 
                    [class.CustomCheckbox--disabled]="isRegionDisabled(regionsArray[i])">
                    <input 
                      type="checkbox" 
                      [formControlName]="i" 
                      [id]="regionsArray[i] + 'Desktop'">
                    <label [for]="regionsArray[i] + 'Desktop'" [ngbTooltip]="tipContent">
                      {{ ('RegionNames.' + regionsArray[i]) | translate }}
                    </label>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="!isReport">
                <div class="col-lg">
                  <div class="FormElement">
                    <select formControlName="country" data-cy="Filter-countries">
                      <option value="">All countries</option>
                      <option *ngFor="let country of countries" [value]="country">
                        {{ ('CountryNames.' + country) | translate }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg">
                  <div class="FormElement">
                    <select formControlName="bandGroup" (change)="onClickBandgroup($event)" data-cy="Filter-bandGroups">
                      <option value="">All groups of bands</option>
                      <option *ngFor="let bandGroup of filterData.bandGroups" [value]="bandGroup.bandGroup">
                        {{ ('GroupOfBands.' + bandGroup.bandGroup) | translate }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg">
                  <div class="FormElement">
                    <select formControlName="band" data-cy="Filter-bands">
                      <option value="">All bands</option>
                      <option *ngFor="let band of bands" [value]="band.code">
                        {{ band.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="isReport">
                <div class="col-lg-8">
                  <div class="FormElement FormElement--long">
                    <select [(ngModel)]="selectedReport" [ngModelOptions]="{standalone: true}" (change)="onReportChange($event)">
                      <option value="upcoming">Recent and upcoming spectrum awards</option>
                      <option value="operators">List of operators</option>
                    </select>
                  </div>
                </div>
              </ng-container>
              <div class="col-lg-2 Filter-button">
                <div class="FormElement">
                  <button 
                    type="button"
                    class="Button Button--blue Button--fullWidth" 
                    (click)="onResetFilter()" 
                    [disabled]="isResetDisabled()">
                    Reset filter
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="Filters-mobile" [ngClass]="{'Filters-mobile--active': filterService.mobileFilterIsOpen}">
    <header>
      <ul class="SocialMenu">
        <li class="Social Social--twitter"><a href="#" target="_blank"></a></li>
        <li class="Social Social--linkedin"><a href="#" target="_blank"></a></li>
      </ul>
      <div class="CloseMobileFilters" (click)="filterService.closeMobileFilterOnClick()"></div>
    </header>
    <div class="Content">
      <div class="Tabs">
        <form [formGroup]="filtersForm">
          <ul>
            <li 
              class="Tab Tab--withLabel" 
              routerLink="/" 
              [class.Active]="isActiveTab('licences')" 
              (click)="onTabChange('licences')">
              <input type="radio" formControlName="category" id="licencesMobile" value="licences">
              <label for="licencesMobile">Licences</label>
            </li>
            <li 
              class="Tab Tab--withLabel" 
              routerLink="/awards" 
              [class.Active]="isActiveTab('awards')" 
              (click)="onTabChange('awards')">
              <input type="radio" formControlName="category" id="awardsMobile" value="awards">
              <label for="awardsMobile">Awards</label>
            </li>
            <li 
              class="Tab Tab--withLabel" 
              routerLink="/reports/upcoming" 
              [class.Active]="isActiveTab('reports')" 
              (click)="onTabChange('reports')">
              <input type="radio" formControlName="category" id="reportsMobile" value="reports">
              <label for="reportsMobile">Reports (2)</label>
            </li>
          </ul>
          <div class="TabContent">
            <div class="row">
              <div class="col-lg Filter-region">
                <div class="FormElement FormElement--mobileMargin">
                  <div 
                    formArrayName="regions" 
                    *ngFor="let region of filtersForm.controls.regions.controls; let i = index" 
                    class="CustomCheckbox CustomCheckbox--inline" 
                    [class.CustomCheckbox--disabled]="isRegionDisabled(regionsArray[i])">
                    <input 
                      type="checkbox" 
                      [formControlName]="i" 
                      [id]="regionsArray[i] + 'Mobile'">
                    <label [for]="regionsArray[i] + 'Mobile'">
                      {{ ('RegionNames.' + regionsArray[i]) | translate }}
                    </label>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="!isReport">
                <div class="col-lg">
                  <div class="FormElement FormElement--mobileMargin">
                    <select formControlName="country">
                      <option value="">All countries</option>
                      <option *ngFor="let country of countries" [value]="country">
                        {{ ('CountryNames.' + country) | translate }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg">
                  <div class="FormElement FormElement--mobileMargin">
                    <select formControlName="bandGroup" (change)="onClickBandgroup($event)">
                      <option value="">All groups of bands</option>
                      <option *ngFor="let bandGroup of filterData.bandGroups" [value]="bandGroup.bandGroup">
                        {{ ('GroupOfBands.' + bandGroup.bandGroup) | translate }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg">
                  <div class="FormElement FormElement--mobileMargin">
                    <select formControlName="band">
                      <option value="">All bands</option>
                      <option *ngFor="let band of bands" [value]="band.code">
                        {{ band.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="isReport">
                <div class="col-lg">
                  <div class="FormElement FormElement--mobileMargin">
                    <select [(ngModel)]="selectedReport" [ngModelOptions]="{standalone: true}" (change)="onReportChange($event)">
                      <option value="upcoming">Recent and upcoming spectrum awards</option>
                      <option value="operators">List of operators</option>
                    </select>
                  </div>
                </div>
              </ng-container>
              <div class="col-lg Filter-button">
                <div class="FormElement">
                  <button 
                    type="button"
                    class="Button Button--blue Button--fullWidth" 
                    (click)="onResetFilter(); filterService.closeMobileFilterOnClick()" 
                    [disabled]="isResetDisabled()">
                    Reset filter
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>